import XMLResponse from "./pages/eButtonServices/xmlResponse";

export const dashboardPagesMenu = {
  dashboard: {
    id: "dashboard",
    text: "Dashboard",
    path: "dashboard",
    icon: "Dashboard",
    subMenu: null,
  },
  dashboardBooking: {
    id: "dashboard-booking",
    text: "Dashboard Booking",
    path: "dashboard-booking",
    icon: "emoji_transportation",
    subMenu: null,
  },
  // summary: {
  // 	id: 'summary',
  // 	text: 'Summary',
  // 	path: 'summary',
  // 	icon: 'sticky_note_2',
  // 	subMenu: null,
  // },
};

export const demoPagesMenu = {
  crm: {
    id: "crm",
    text: "CRM",
    path: "crm",
    icon: "Contacts",
    subMenu: {
      dashboard: {
        id: "dashboard",
        text: "CRM Dashboard",
        path: "crm/dashboard",
        icon: "RecentActors",
      },
      MerchantsList: {
        id: "merchantsList",
        text: "Merchants",
        path: "crm/merchants",
        icon: "PersonSearch",
      },
      customersList: {
        id: "customersList",
        text: "Customers",
        path: "crm/customers",
        icon: "PersonSearch",
      },
      customerID: {
        id: "customerID",
        text: "customerID",
        path: "crm/customer",
        hide: true,
      },
      customer: {
        id: "customer",
        text: "Customer",
        path: "crm/customer/1",
        icon: "Badge",
      },
      // sales: {
      // 	id: 'sales',
      // 	text: 'Sales',
      // 	path: 'crm/sales',
      // 	icon: 'Storefront',
      // },
      invoiceID: {
      	id: 'invoiceID',
      	text: 'invoiceID',
      	path: 'crm/invoice',
      	hide: true,
      },
      InvoicesList: {
        id: "invoice",
        text: "Invoice",
        path: "invoices",
        icon: "Receipt",
      },
    },
  },
  auth: {
    id: "auth",
    text: "Auth Pages",
    icon: "Extension",
  },

  login: {
    id: "login",
    text: "Login",
    path: "auth-pages/login",
    icon: "Login",
  },
  signUp: {
    id: "signUp",
    text: "Sign Up",
    path: "auth-pages/sign-up",
    icon: "PersonAdd",
  },
  page404: {
    id: "Page404",
    text: "404 Page",
    path: "auth-pages/404",
    icon: "ReportGmailerrorred",
  },
  SetPassword: {
    id: "setpassword",
    text: "setpassword",
    path: "auth-pages/setpassword",
    icon: "setpassword",
  },
  forgotpassword: {
    id: "forgotpassword",
    text: "forgotpassword",
    path: "auth-pages/forgotpassword",
    icon: "forgotpassword",
  },
};
export const adminDashboardMenu = {
  dashboard: {
    id: "dashboard",
    text: "Dashboard",
    path: "dashboard",
    icon: "Dashboard",
    submenu: null,
  },
  merchants: {
    id: "merchant",
    text: "Merchants",
    path: "merchants",
    icon: "WorkOutline",
  },

  customers: {
    id: "customers",
    text: "Customers",
    path: "customers",
    icon: "ImportContacts",
  },
  items: {
    id: "items",
    text: "Items",
    path: "items",
    icon: "FileCopy",
  },
  invoices: {
    id: "invoices",
    text: "Invoices",
    path: "invoices",
    icon: "AddTask",
  },
  eButton: {
    id: "ebutton",
    text: "eButton",
    path: "ebuttons",
    icon: "ReceiptLong",
  },
  settings: {
    id: "settings/:id",
    text: "Settings",
    path: "settings",
    icon: "settings",
  },
  logout: {
    id: "logout",
    text: "Logout",
    path: "auth/logout",
    icon: "Logout",
  },
};

export const PageHeader = {

   //Merchantss section//
   AddMerchant: {
    id: "createmerchant",
    text: "Create Merchant",
    path: "createmerchant",
  },
  UpdateMerchant: {
    id: "updatemerchant",
    text: "Update Merchant",
    path: "updatemerchant/:id",
  },
  UpdateSubMerchant: {
    id: "updatesubmerchant",
    text: "Update Submerchant",
    path: "updatesubmerchant/:id",
  },
  UploadSubMerchants: {
    id: "importmerchants",
    text: "importmerchants",
    path: "importmerchants",
  },


  //customers section//
  CreateCustomer: {
    id: "createcustomer",
    text: "Create Customer",
    path: "createcustomer",
  },
  UpdateCustomer: {
    id: "updatecustomer",
    text: "Update Customer",
    path: "updatecustomer/:id",
  },
  EmailCustomer: {
    id: "emailcustomer",
    text: "Email Customer",
    path: "emailcustomer/:id",
  },
  UploadCustomers: {
    id: "importcustomers",
    text: "Import Customers",
    path: "importcustomers",
  },

  //items section//
   CreateItem: {
    id: "createitem",
    text: "Create Item",
    path: "createitem",
  },
  UpdateItem: {
    id: "updateitem",
    text: "updateitem",
    path: "updateitem/:id",
  },
  UploadItems: {
    id: "importitems",
    text: "Import Items",
    path: "importitems",
  },

  //Invoices section//
  CreateInvoice: {
    id: "createinvoice",
    text: "Create invoice",
    path: "createinvoice",
  },
  UpdateInvoice: {
    id: "updateinvoice",
    text: "Update Invoice",
    path: "updateinvoice/:id",
  },
  CreateInvoiceItem: {
    id: "createinvoice",
    text: "Create Invoice Item",
    path: "createinvoiceitem/:id",
  },
  UpdateInvoiceItem: {
    id: "updateinvoiceitem",
    text: "Update Invoice Item",
    path: "updateinvoiceitem/:id",
  },
  UploadInvoices: {
    id: "uploadinvoices",
    text: "Upload Invoices",
    path: "uploadinvoices",
  },
  Payments: {
    id: "payments",
    text: "payments",
    path: "payments/:id",
  },

   //eButtons section//
   CreateEButton: {
    id: "ebuttoncreate",
    text: "eButton create",
    path: "ebuttoncreate",
  },
  UpdateEbutton: {
    id: "ebuttonupdate",
    text: "eButton Update",
    path: "ebuttonupdate/:id",
  },
  GenerateCode: {
    id: "generatecode",
    text: "Generate Code",
    path: "generatecode/:id",
  },
  // Users section //
  CreateSuperUser: {
    id: "createUser",
    text: "Create User",
    path: "createUser",
  },
  UpdateSuperUser: {
    id: "updateUser",
    text: "Update User",
    path: "updateUser/:id",
  },

  //profile //
  ProfileCard: {
    id: "profile",
    text: "profile",
    path: "profile",
  },
 
};

export const authPages = {
  login: {
    id: "login",
    text: "Login",
    path: "/",
    icon: "Login",
  },
  otp: {
    id: "otp",
    text: "OTP",
    path: "auth/otp",
    icon: "VpnKey",
  },
  setpassword: {
    id: "setpassword",
    text: "Set Password",
    path: "auth/setpassword",
    icon: "VpnKey",
  },
  forgotpassword: {
    id: "forgotpassword",
    text: "forgot password",
    path: "auth/forgotpassword",
    icon: "VpnKey",
  },
  payinvoice: {
    id: "payinvoice",
    text: "pay invoice",
    path: "payinvoice/:id",
  },
  PaymentFormEbutton: {
    id: "paymentebutton",
    text: "payment ebutton",
    path: "checkout",
  },
  paymentsuccess: {
    id: "paymentsuccess",
    text: "payment success",
    path: "paymentsuccess",
  },
  PaymentLinkNotFound: {
    id: "PaymentLinkNotFound",
    text: "PaymentLinkNotFound",
    path: "paymentlinknotfound",
  },
  NotFoundRedirect: {
    id: "inventorynotfound",
    text: "not found inventory",
    path: "inventorynotfound",
  },
  Page404: {
    id: "page404",
    text: "page 404 not found",
    path: "notfound",
  },
  CustomerUpdateToken: {
    id: "customerupdatetoken",
    text: "customerupdatetoken",
    path: "customerupdatetoken/:id",
  },
  eButtonService: {
    id: "eButtonService",
    text: "eButtonService",
    path: "ebutton-docs",
  },
  CreateEbuttonService: {
    id: "createEbuttonService",
    text: "createEbuttonService",
    path: "ebutton-docs/CreateButton",
  },
  DeleteButtonForm: {
    id: "deleteEbutton",
    text: "deleteEbutton",
    path: "ebutton-docs/DeleteButton",
  },
  EditEbuttonService: {
    id: "eButtonService",
    text: "EditButton",
    path: "ebutton-docs/EditButton",
  },
  GetTransactionById: {
    id: "GetTransactionsByButtonId",
    text: "GetTransactionsByButtonId",
    path: "ebutton-docs/GetTransactionsByButtonId",
  },
  GetTransactionByRefrenceNumber: {
    id: "GetTransactionsByReferenceNumber",
    text: "GetTransactionsByReferenceNumber",
    path: "ebutton-docs/GetTransactionsByReferenceNumber",
  },
  GetEbuttonTransactions: {
    id: "GetButtonTransactions",
    text: "GetButtonTransactions",
    path: "ebutton-docs/GetButtonTransactions",
  },
  XMLResponse: {
    id: "XMLResponse",
    text: "XML Response",
    path: "ebutton-docs/:action", 
    validActions: [
      'createbuttonresponse',
      'editbuttonresponse',
      'getTransactionsbybuttonidresponse',
      'deletebuttonresponse',
      'gettransactionsbyreferencenumberresponse',
      'getebuttontransactionsresponse'
    ]
  }

};

export const componentPagesMenu = {
  bootstrap: {
    id: "bootstrap",
    text: "Bootstrap",
    icon: "Extension",
  },
  components: {
    id: "components",
    text: "Component",
    path: "components",
    icon: "Extension",
    notification: "success",
    subMenu: {
      accordion: {
        id: "accordion",
        text: "Accordion",
        path: "components/accordion",
        icon: "ViewDay",
      },
      alert: {
        id: "alert",
        text: "Alert",
        path: "components/alert",
        icon: "Announcement",
      },
      badge: {
        id: "badge",
        text: "Badge",
        path: "components/badge",
        icon: "Vibration",
      },
      breadcrumb: {
        id: "breadcrumb",
        text: "Breadcrumb",
        path: "components/breadcrumb",
        icon: "AddRoad",
      },
      button: {
        id: "button",
        text: "Button",
        path: "components/button",
        icon: "SmartButton",
      },
      buttonGroup: {
        id: "buttonGroup",
        text: "Button Group",
        path: "components/button-group",
        icon: "Splitscreen",
      },
      card: {
        id: "card",
        text: "Card",
        path: "components/card",
        icon: "Crop32",
      },
      carousel: {
        id: "carousel",
        text: "Carousel",
        path: "components/carousel",
        icon: "RecentActors",
      },
      // Close
      collapse: {
        id: "collapse",
        text: "Collapse",
        path: "components/collapse",
        icon: "UnfoldLess",
      },
      dropdowns: {
        id: "dropdowns",
        text: "Dropdowns",
        path: "components/dropdowns",
        icon: "Inventory",
      },
      listGroup: {
        id: "listGroup",
        text: "List Group",
        path: "components/list-group",
        icon: "ListAlt",
      },
      modal: {
        id: "modal",
        text: "Modal",
        path: "components/modal",
        icon: "PictureInPicture",
      },
      navsTabs: {
        id: "navsTabs",
        text: "Navs & Tabs",
        path: "components/navs-and-tabs",
        icon: "PivotTableChart",
      },
      // Navbar
      offcanvas: {
        id: "offcanvas",
        text: "Offcanvas",
        path: "components/offcanvas",
        icon: "VerticalSplit",
      },
      pagination: {
        id: "pagination",
        text: "Pagination",
        path: "components/pagination",
        icon: "Money",
      },
      popovers: {
        id: "popovers",
        text: "Popovers",
        path: "components/popovers",
        icon: "Assistant",
      },
      progress: {
        id: "progress",
        text: "Progress",
        path: "components/progress",
        icon: "HourglassTop",
      },
      scrollspy: {
        id: "scrollspy",
        text: "Scrollspy",
        path: "components/scrollspy",
        icon: "KeyboardHide",
      },
      spinners: {
        id: "spinners",
        text: "Spinners",
        path: "components/spinners",
        icon: "RotateRight",
      },
      table: {
        id: "table",
        text: "Table",
        path: "components/table",
        icon: "TableChart",
      },
      toasts: {
        id: "toasts",
        text: "Toasts",
        path: "components/toasts",
        icon: "RotateRight",
      },
      tooltip: {
        id: "tooltip",
        text: "Tooltip",
        path: "components/tooltip",
        icon: "Assistant",
      },
    },
  },
  forms: {
    id: "forms",
    text: "Forms",
    path: "forms",
    icon: "CheckBox",
    notification: "success",
    subMenu: {
      formGroup: {
        id: "formGroup",
        text: "Form Group",
        path: "forms/form-group",
        icon: "Source",
      },
      formControl: {
        id: "formControl",
        text: "Form Controls",
        path: "forms/form-controls",
        icon: "Create",
      },
      select: {
        id: "select",
        text: "Select",
        path: "forms/select",
        icon: "Checklist",
      },
      checksAndRadio: {
        id: "checksAndRadio",
        text: "Checks & Radio",
        path: "forms/checks-and-radio",
        icon: "CheckBox",
      },
      range: {
        id: "range",
        text: "Range",
        path: "forms/range",
        icon: "HdrStrong",
      },
      inputGroup: {
        id: "inputGroup",
        text: "Input Group",
        path: "forms/input-group",
        icon: "PowerInput",
      },
      validation: {
        id: "validation",
        text: "Validation",
        path: "forms/validation",
        icon: "VerifiedUser",
      },
      wizard: {
        id: "wizard",
        text: "Wizard",
        path: "forms/wizard",
        icon: "LinearScale",
      },
    },
  },
  content: {
    id: "content",
    text: "Content",
    path: "content",
    icon: "format_size",
    subMenu: {
      typography: {
        id: "typography",
        text: "Typography",
        path: "content/typography",
        icon: "text_fields",
      },
      images: {
        id: "images",
        text: "Images",
        path: "content/images",
        icon: "Image ",
      },
      tables: {
        id: "tables",
        text: "Tables",
        path: "content/tables",
        icon: "table_chart",
      },
      figures: {
        id: "figures",
        text: "Figures",
        path: "content/figures",
        icon: "Photo Library ",
      },
    },
  },
  utilities: {
    id: "utilities",
    text: "Utilities",
    path: "utilities",
    icon: "Support",
    subMenu: {
      api: {
        id: "api",
        text: "API",
        path: "utilities/api",
        icon: "Api",
      },
      background: {
        id: "background",
        text: "Background",
        path: "utilities/background",
        icon: "FormatColorFill",
      },
      borders: {
        id: "borders",
        text: "Borders",
        path: "utilities/borders",
        icon: "BorderStyle",
      },
      colors: {
        id: "colors",
        text: "Colors",
        path: "utilities/colors",
        icon: "InvertColors",
      },
      display: {
        id: "display",
        text: "Display",
        path: "utilities/display",
        icon: "LaptopMac",
      },
      flex: {
        id: "flex",
        text: "Flex",
        path: "utilities/flex",
        icon: "SettingsOverscan",
      },
      float: {
        id: "float",
        text: "Float",
        path: "utilities/float",
        icon: "ViewArray",
      },
      interactions: {
        id: "interactions",
        text: "Interactions",
        path: "utilities/interactions",
        icon: "Mouse",
      },
      overflow: {
        id: "overflow",
        text: "Overflow",
        path: "utilities/overflow",
        icon: "TableRows",
      },
      position: {
        id: "position",
        text: "Position",
        path: "utilities/position",
        icon: "Adjust",
      },
      shadows: {
        id: "shadows",
        text: "Shadows",
        path: "utilities/shadows",
        icon: "ContentCopy",
      },
      sizing: {
        id: "sizing",
        text: "Sizing",
        path: "utilities/sizing",
        icon: "Straighten",
      },
      spacing: {
        id: "spacing",
        text: "Spacing",
        path: "utilities/spacing",
        icon: "SpaceBar",
      },
      text: {
        id: "text",
        text: "Text",
        path: "utilities/text",
        icon: "TextFields",
      },
      verticalAlign: {
        id: "vertical-align",
        text: "Vertical Align",
        path: "utilities/vertical-align",
        icon: "VerticalAlignCenter",
      },
      visibility: {
        id: "visibility",
        text: "Visibility",
        path: "utilities/visibility",
        icon: "Visibility",
      },
    },
  },
  extra: {
    id: "extra",
    text: "Extra Library",
    icon: "Extension",
    path: undefined,
  },
  icons: {
    id: "icons",
    text: "Icons",
    path: "icons",
    icon: "Grain",
    notification: "success",
    subMenu: {
      icon: {
        id: "icon",
        text: "Icon",
        path: "icons/icon",
        icon: "Lightbulb",
      },
      material: {
        id: "material",
        text: "Material",
        path: "icons/material",
        icon: "Verified",
      },
    },
  },
  charts: {
    id: "charts",
    text: "Charts",
    path: "charts",
    icon: "AreaChart",
    notification: "success",
    subMenu: {
      chartsUsage: {
        id: "chartsUsage",
        text: "General Usage",
        path: "charts/general-usage",
        icon: "Description",
      },
      chartsSparkline: {
        id: "chartsSparkline",
        text: "Sparkline",
        path: "charts/sparkline",
        icon: "AddChart",
      },
      chartsLine: {
        id: "chartsLine",
        text: "Line",
        path: "charts/line",
        icon: "ShowChart",
      },
      chartsArea: {
        id: "chartsArea",
        text: "Area",
        path: "charts/area",
        icon: "AreaChart",
      },
      chartsColumn: {
        id: "chartsColumn",
        text: "Column",
        path: "charts/column",
        icon: "BarChart",
      },
      chartsBar: {
        id: "chartsBar",
        text: "Bar",
        path: "charts/bar",
        icon: "StackedBarChart",
      },
      chartsMixed: {
        id: "chartsMixed",
        text: "Mixed",
        path: "charts/mixed",
        icon: "MultilineChart",
      },
      chartsTimeline: {
        id: "chartsTimeline",
        text: "Timeline",
        path: "charts/timeline",
        icon: "WaterfallChart",
      },
      chartsCandleStick: {
        id: "chartsCandleStick",
        text: "Candlestick",
        path: "charts/candlestick",
        icon: "Cake",
      },
      chartsBoxWhisker: {
        id: "chartsBoxWhisker",
        text: "Box Whisker",
        path: "charts/box-whisker",
        icon: "SportsMma",
      },
      chartsPieDonut: {
        id: "chartsPieDonut",
        text: "Pie & Donut",
        path: "charts/pie-donut",
        icon: "PieChart",
      },
      chartsRadar: {
        id: "chartsRadar",
        text: "Radar",
        path: "charts/radar",
        icon: "BrightnessLow",
      },
      chartsPolar: {
        id: "chartsPolar",
        text: "Polar",
        path: "charts/polar",
        icon: "TrackChanges",
      },
      chartsRadialBar: {
        id: "chartsRadialBar",
        text: "Radial Bar",
        path: "charts/radial-bar",
        icon: "DonutLarge",
      },
      chartsBubble: {
        id: "chartsBubble",
        text: "Bubble",
        path: "charts/bubble",
        icon: "BubbleChart",
      },
      chartsScatter: {
        id: "chartsScatter",
        text: "Scatter",
        path: "charts/scatter",
        icon: "ScatterPlot",
      },
      chartsHeatMap: {
        id: "chartsHeatMap",
        text: "Heat Map",
        path: "charts/heat-map",
        icon: "GridOn",
      },
      chartsTreeMap: {
        id: "chartsTreeMap",
        text: "Tree Map",
        path: "charts/tree-map",
        icon: "AccountTree",
      },
    },
  },
  notification: {
    id: "notification",
    text: "Notification",
    path: "notifications",
    icon: "NotificationsNone",
  },
  hooks: {
    id: "hooks",
    text: "Hooks",
    path: "hooks",
    icon: "Anchor",
  },
};
